let firebaseConfig = {
  apiKey: "AIzaSyDMNoKesaJGIqDxmHDyqUkWTmExSm1Lxk8",
  authDomain: "cattlebirths.firebaseapp.com",
  databaseURL: "https://cattlebirths.firebaseio.com",
  projectId: "cattlebirths",
  storageBucket: "cattlebirths.appspot.com",
  messagingSenderId: "395998449243",
  appId: "1:395998449243:web:97bad3328882649a52797e",
  measurementId: "G-QHW9B2913E",
};

export default firebaseConfig;
